import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bool } from "prop-types";
import { Link } from "react-router-dom";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import Drawer from "pages/_components/Drawer/Drawer";
import { actions as debinActions } from "reducers/debin";
import { debinOptions } from "util/debin";
import moment from "moment";
import { getLimitDate } from "util/date";
import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import TitleColumns from "./components/TitleColumns";
import ReceivedDebinItem from "./components/ItemRow";
import EmitedSideBarForm from "../_components/SideBarForm";
import FilterTags from "../_components/FilterTags";

const ReceivedDebin = ({ isDesktop }) => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });
    const { fetching, sentRequests, totalPages, pageNumber, filterRecurrencyList } = useSelector(
        (state) => state.debin,
    );
    const [debinPagination, setDebinPagination] = useState(pageNumber);
    const hasMoreData = pageNumber < totalPages;
    const dispatch = useDispatch();
    const row = isDesktop ? 1 : 4;

    const openSideBarFilters = () => {
        setOpenSidebar(true);
    };

    const fetchMoreTransactions = () => {
        setDebinPagination(pageNumber + 1);
        dispatch(debinActions.loadIncomingRequests({ ...filterRecurrencyList, pageNumber: debinPagination + 1 }));
    };

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null, title: "" });
    };
    useEffect(() => {
        const data = {
            dateFrom: getLimitDate(-7),
            dateTo: moment().toDate(),
            seller: "",
            status: "INICIADO",
            pageNumber: 1,
        };
        dispatch(debinActions.setRecurrencyDebinFilters({ ...data, pageNumber: 1 }));
        dispatch(debinActions.loadIncomingRequests({ ...data }));
    }, []);

    const debinList = sentRequests?.debinList?.map((debinMap) => ({ ...debinMap, status: debinMap.status.code }));
    return (
        <div className="container">
            <FilterTags openSideBarFilters={openSideBarFilters} optiondebin={debinOptions[1]} isReceived />
            {debinList?.length ? (
                <>
                    <ProductList
                        fetchingWithPreviousData
                        fetching={fetching}
                        items={debinList || []}
                        noDataText="global.no.results"
                        noFiltersDataText="debin.recived.no.results"
                        renderItem={(item) => (
                            <GridTable.Container
                                key={`emited-debin-item-${item.id}`}
                                renderAs={Link}
                                to={`/debin/recived/detail/${item.id}`}
                                className={!isDesktop && "box box-shadow"}>
                                <ReceivedDebinItem
                                    key={`transaction-${item.id}`}
                                    receibedDebin={item}
                                    setDrawer={setActionDrawer}
                                    isDesktop={isDesktop}
                                />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <>
                                <GridTable className="debin-table">
                                    <GridTable.Header>
                                        <GridTable.Container rows={row}>
                                            <TitleColumns />
                                        </GridTable.Container>
                                    </GridTable.Header>
                                    <GridTable.Body>{listItem}</GridTable.Body>
                                </GridTable>
                                {hasMoreData && (
                                    <Button
                                        bsStyle="link"
                                        onClick={() => fetchMoreTransactions()}
                                        image="images/figma/icon/arrow.svg"
                                        label="global.showMore"
                                        className="view-more"
                                    />
                                )}
                            </>
                        )}
                    </ProductList>
                </>
            ) : (
                <EmptyScreenAlert message="debin.service.empty.recived" />
            )}
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <EmitedSideBarForm closeSidebar={setOpenSidebar} isReceived />
            </Drawer>
            <Drawer openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                {actionDrawer.contentDrawer}
            </Drawer>
        </div>
    );
};

ReceivedDebin.propTypes = {
    isDesktop: bool.isRequired,
};

export default ReceivedDebin;
